import React, { FC, useEffect } from 'react';

import { Controller, useFormContext } from 'react-hook-form';
import { TranslationKey, useTranslations } from '@lang';

import { useIsDesktop } from '@common/hooks/useIsDesktop';

import { BlockSelectField } from '@common/components/FormElements/BlockSelectField';
import TimeSlotOptionHOC from '../TimeSlotOptionHOC';
import { SpaEntityFormValues } from '@common/components/SpaEntity/SpaEntityForm.schema';

const TimeSlotOption = (props) => <TimeSlotOptionHOC parentType="Option" {...props} />;
const TimeSlotValue = (props) => <TimeSlotOptionHOC parentType="SingleValue" {...props} />;

export const TimeSlotSelector: FC<{
  arrivalTimesOptions: any[];
  disabled: boolean;
  labelTranslation?: TranslationKey;
  showPerPerson?: boolean;
}> = ({ arrivalTimesOptions, disabled, labelTranslation = 'spa.selectArrival', showPerPerson }) => {
  const { t, formatTime } = useTranslations();
  const isDesktop = useIsDesktop();
  const { control, setValue } = useFormContext<SpaEntityFormValues>();

  useEffect(() => {
    if (arrivalTimesOptions.length === 1) {
      setValue('arrivalTime', arrivalTimesOptions[0]);
    }
  }, [arrivalTimesOptions, setValue]);

  return arrivalTimesOptions ? (
    <Controller
      control={control}
      name="arrivalTime"
      render={({ field: { value, onChange } }) => (
        <BlockSelectField
          key={arrivalTimesOptions.map((o) => o.startDateTime).join(',')}
          components={{
            Option: (props) => TimeSlotOption({ ...props, showPerPerson }),
            SingleValue: (props) => TimeSlotValue({ ...props, showPerPerson }),
          }}
          {...({ getOptionValue: (option: any) => option.startDateTime } as any)}
          value={value ?? null}
          isSearchable={false}
          menuPlacement={isDesktop ? 'auto' : 'top'}
          label={t(labelTranslation)}
          isRequired
          options={arrivalTimesOptions}
          noOptionsMessage={() => t('treatment.noTimeslotsAvailable')}
          placeholder={t('product.selectPlaceholder')}
          useNativeDropdownOnMobile={true}
          renderMobileOption={(option: any) => formatTime(option.startDateTime)}
          onChange={onChange}
          id="time-slot-selector"
          isDisabled={disabled}
        />
      )}
    />
  ) : null;
};
